import { render } from "./MainView.vue?vue&type=template&id=0e3fddb5&scoped=true"
const script = {}

import "./MainView.vue?vue&type=style&index=0&id=0e3fddb5&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3fddb5"]])

export default __exports__